module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[36]401.e7efcbd.woff2";